import React, { useState } from 'react';
import { UserProfile } from './UserProfile';
import { UserWebContent } from './UserWebContent';
import { UserProductListings } from './UserProductListings';

export const UserDetailTabs = ({ user, networkId }) => {
  const [activeTab, setActiveTab] = useState(() => {
    return localStorage.getItem('userDetailActiveTab') || 'profile';
  });

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    localStorage.setItem('userDetailActiveTab', tab);
  };

  return (
    <div>
      <ul className="nav nav-tabs">
        <li className="nav-item">
          <button
            className={'nav-link ' + (activeTab === 'profile' ? 'active' : '')}
            onClick={() => handleTabChange('profile')}
          >
            User Profile
          </button>
        </li>
        <li className="nav-item">
          <button
            className={'nav-link ' + (activeTab === 'webcontent' ? 'active' : '')}
            onClick={() => handleTabChange('webcontent')}
          >
            Operate Components
          </button>
        </li>
        <li className="nav-item">
          <button
            className={'nav-link ' + (activeTab === 'listings' ? 'active' : '')}
            onClick={() => handleTabChange('listings')}
          >
            Product Listings
          </button>
        </li>
      </ul>

      <div className="tab-content bg-white border border-top-0 rounded-bottom">
        {activeTab === 'profile' && <UserProfile user={user} />}
        {activeTab === 'webcontent' && <UserWebContent user={user} />}
        {activeTab === 'listings' && <UserProductListings user={user} networkId={networkId} />}
      </div>
    </div>
  );
};